/**
 * ThinkingPhrases.js - Centralized thinking/loading phrases for all co-pilots
 * 
 * Single source of truth for the fun loading messages shown while AI is processing.
 */
import { useState, useEffect } from 'react';

// Fun thinking phrases for the loading state
export const THINKING_PHRASES = [
  "Boiling the ocean...",
  "Synergizing the synergy...",
  "Circling back now...",
  "Pivoting the tables...",
  "Unpacking the deliverables...",
  "Drilling down deeper...",
  "Leveraging core competencies...",
  "Moving the needle...",
  "Aligning the stakeholders...",
  "Thinking outside boxes...",
  "Disrupting the industry...",
  "Picking low-hanging fruit...",
  "Crunching the numbers...",
  "Coercing the algorithms...",
  "Untangling the data...",
  "Training the models...",
  "Sweating the assets...",
  "Connecting the dots...",
  "Herding digital cats...",
  "Polishing the pixels...",
  "Scrubbing the inputs...",
  "Consulting the oracle...",
  "Waking the hamsters...",
  "Generating value add...",
  "Calibrating expectations now...",
  "Inventing new metrics...",
  "Quantifying the qualitative...",
  "Ranking the invisible...",
  "Justifying the existence...",
  "Comparing apples to oranges...",
  "Maximizing the minimum...",
  "Minimizing the maximum...",
  "Optimizing the suboptimal...",
  "Reticulating splines...",
  "Defragmenting thoughts...",
  "Compiling insights...",
  "Parsing the unparseable...",
  "Debugging reality...",
  "Refactoring assumptions...",
  "Deploying brain cells...",
  "Spinning up neurons...",
  "Buffering brilliance...",
  "Loading creativity...",
  "Initializing wisdom...",
  "Bootstrapping solutions...",
  "Hydrating knowledge...",
  "Warming up the AI...",
  "Fetching inspiration...",
  "Querying the cosmos...",
  "Mining for gold...",
  "Sifting through data...",
  "Brewing fresh ideas...",
  "Distilling insights...",
  "Fermenting thoughts...",
  "Marinating concepts...",
  "Seasoning responses...",
  "Plating the analysis...",
  "Garnishing with wisdom...",
  "Serving hot takes...",
  "Crafting the narrative...",
  "Weaving the story...",
  "Painting the picture...",
  "Sculpting the answer...",
  "Composing a symphony...",
  "Orchestrating ideas...",
  "Conducting analysis...",
  "Harmonizing data...",
  "Tuning the response...",
  "Fine-tuning insights...",
];

/**
 * Hook to manage rotating thinking phrases with fade animation
 * @param {boolean} isActive - Whether the thinking animation should run
 * @returns {{ phrase: string, isVisible: boolean }}
 */
export const useThinkingPhrases = (isActive) => {
  const [phrase, setPhrase] = useState(() => 
    THINKING_PHRASES[Math.floor(Math.random() * THINKING_PHRASES.length)]
  );
  const [isVisible, setIsVisible] = useState(true);
  
  useEffect(() => {
    if (!isActive) return;
    
    const interval = setInterval(() => {
      // Fade out
      setIsVisible(false);
      
      // Change phrase after fade out
      setTimeout(() => {
        setPhrase(THINKING_PHRASES[Math.floor(Math.random() * THINKING_PHRASES.length)]);
        setIsVisible(true);
      }, 200);
    }, 2500);
    
    return () => clearInterval(interval);
  }, [isActive]);
  
  return { phrase, isVisible };
};

export default THINKING_PHRASES;
